module.exports = __webpack_public_path__ + "img/hone_bg.68191258.png";